import React, { useEffect } from 'react';
import * as THREE from 'three';
import { STLLoader } from 'three/examples/jsm/loaders/STLLoader';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';

import { Three as Singleton } from './Three';


const Loader = props => {

  const {
    onLoaded,
  } = props;

  useEffect(
    () => {
      const {
        Color,
        DirectionalLight,
        Fog,
        GridHelper,
        HemisphereLight,
        Mesh,
        MeshPhongMaterial,
        PerspectiveCamera,
        PlaneGeometry,
        Scene,
        Vector3,
        WebGLRenderer,
        sRGBEncoding,
      } = THREE;

      const three = {
        Color,
        DirectionalLight,
        Fog,
        GridHelper,
        HemisphereLight,
        Mesh,
        MeshPhongMaterial,
        PerspectiveCamera,
        PlaneGeometry,
        Scene,
        Vector3,
        WebGLRenderer,
        sRGBEncoding,
      };

      Singleton.Set({ THREE: three, STLLoader, OrbitControls });
      if (onLoaded) {
        onLoaded();
      }
    },
    [
      onLoaded,
    ],
  );

  return <></>;
};

export default Loader;
